import { formatDate } from '@/@core/utils/utils'
import { judgeStrength } from '@/views/analyze/ACMG'
import { getACMG } from '@/views/analyze/ACMG/ACMGClassification'
import { classify } from '@/views/analyze/ACMG/ACMGClassificationNew'
import { ACMG_evidences_en } from '../CurrentRepoet'
import { handleSetVlaue, handleSetVlaue2 } from '../new-report/FormReport'

export const getTemplate4 = (
  report: any,
  reportValue: any,
  reportsVariants: any[],
  reportsVariantsType: any,
  samples: any[],
  userAcmgData: any[],
  setsValue: any,
  setsValue2: any,
  t: any
) => {
  return [
    {
      type: 'block-title',
      children: [
        {
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },
    {
      type: 'header2-color',
      children: [
        {
          text: '单基因病携带者筛查报告单'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '基本信息：'
        }
      ]
    },
    {
      type: 'block-patient-info',
      children: [
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `姓名`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [{ text: `${reportValue.patient?.patientName ?? '-'}` }]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `性别`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [
            {
              text: `${t((reportValue?.patient?.gender as string) ?? '-')}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `年龄`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [
            {
              text: `${
                reportValue.patient?.dateOfBirth
                  ? (Math.floor(
                      (new Date().valueOf() -
                        new Date(reportValue.patient?.dateOfBirth).valueOf()) /
                        3.15576e10
                    ) <= 0
                      ? 0
                      : Math.floor(
                          (new Date().valueOf() -
                            new Date(
                              reportValue.patient?.dateOfBirth
                            ).valueOf()) /
                            3.15576e10
                        )) + '岁'
                  : '-'
              }`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `样本编号`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [
            {
              text: `${reportValue.sample?.id ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `样本类型`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [
            {
              text: `${reportValue?.sample?.vcfType?.toLocaleUpperCase()}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `联系方式`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [
            {
              text: `${reportValue?.patient?.phone ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `送检单位`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [
            {
              text: `${reportValue?.patient?.infirmaryName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `科室`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [
            {
              text: `${reportValue?.patient?.departmentName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `送样日期`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed',
          children: [
            {
              text: `${
                formatDate(report?.createdAt, 'YYYY/MM/DD/HH/mm/ss') ?? '-'
              }`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `分析项目`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-88',
          children: [
            {
              text: `多种常见遗传疾病基因检测（246  基因）`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `孕周`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-88',
          children: [
            {
              text: `-`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `病史摘要`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-88',
          children: [
            {
              text: `筛查`
            }
          ]
        },
        {
          type: 'p3-genetic-key-dashed',
          children: [
            {
              text: `检测方法`
            }
          ]
        },
        {
          type: 'p3-genetic-value-dashed-88',
          children: [
            {
              text: `GenCap®+NGS`
            }
          ]
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '结果提示： '
        },
        {
          type: 'radio-group',
          children: [
            {
              text: '结果提示： □疾病高风险 □疾病中风险 □携带者  □阴性'
            }
          ]
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '检测范围内，发现高风险的基因变异位点的携带，请结合受检者配偶检测结果、家族史等进行遗传咨询。'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '点突变（SNVs）或缺失重复（CNVs）分析结果：'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color',
              children: [{ text: '基因' }]
            },
            {
              type: 'table-cell-color',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '染色体'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '位置'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '转录本'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '外显子'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '核苷酸'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '氨基酸'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '纯和/杂合' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'gAD_EAS' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'ACMG 致病性分析(分值)' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '疾病名称' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '临床意义' }]
            }
          ]
        },
        ...reportsVariants.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.gene
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        type: 'p3-center',
                        children: [
                          {
                            type: 'p3-center',
                            children: [
                              {
                                text: `${row.chrom}:${row.pos}`
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        type: 'p3-center',
                        children: [
                          {
                            type: 'p3-center',
                            children: [
                              {
                                text: `${row.transcript}`
                              }
                            ]
                          },
                          {
                            type: 'p3-center',
                            children: [
                              {
                                text: `${row.var_location}${
                                  row.exon === '.' ? '' : `(${row.exon})`
                                }`
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.c_nomen ?? '-'
                      }
                    ]
                  },
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.p_nomen
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.allele_frequency
                          ? row.allele_frequency < 0.85
                            ? t('heterozygote')
                            : t('homozygote')
                          : '无'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: `${row.gnomAD_exome_EAS}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.user_acmg_classification
                          ? row.user_acmg_classification
                              ?.split(' ')
                              .map((word: string) => {
                                if (word.includes('Uncertain')) return `VU`
                                if (word.includes('uncertain')) return `VU`
                                if (word.includes('null')) return ``
                                else return word[0].toUpperCase()
                              })
                              .join('')
                          : row.ACMG_classification
                          ? row.ACMG_classification?.split(' ')
                              .map((word: string) => {
                                if (word.includes('Uncertain')) return `VU`
                                if (word.includes('uncertain')) return `VU`
                                if (word.includes('null')) return ``
                                else return word[0].toUpperCase()
                              })
                              .join('')
                          : row.classification
                          ? row.classification
                              ?.split(' ')
                              .map((word: string) => {
                                if (word.includes('Uncertain')) return `VU`
                                if (word.includes('uncertain')) return `VU`
                                if (word.includes('null')) return ``
                                else return word[0].toUpperCase()
                              })
                              .join('')
                          : ''
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.OMIMCN ?? '-'
                      }
                    ]
                  },
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.OMIM?.geneMim
                          ? `OMIM ID: ${row.OMIM?.geneMim}`
                          : ''
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: t(row.variantsType)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '注：预测：蛋白功能预测软件 REVEL：D:有害;LD:可能有害;U:不确定;LB:可能良性;B:良性.    spliceAI ：T:影响剪接;F:不影响剪接. -:未知 分值：贝叶斯框架 Uncertain 位点分值及对应的致病性概率：<0(0.1%); 0(10%); 1(18.8%); 2(32.5%); 3(50%); 4(67.5%); 5(81.2%);   ≥6(≥ 90%)'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '临床意义：基因变异对受检者健康的影响，“疾病风险”代表受检者发生相关疾病的风险很高；“携带”代表受检者发病风险很低，但 是要关注配偶的变异位点携带和生育风险；'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '结果分析：'
        }
      ]
    },
    {
      type: 'h5-genetic',
      children: [
        {
          text: '1） 基因变异信息详细解读：'
        }
      ]
    },
    ...reportsVariants.map((items, index) => {
      return {
        type: 'paragraph-2',
        children: [
          {
            type: 'paragraph-2',
            children: [
              {
                text: `该样本分析到 ${items?.gene} 基因有 1 个杂合突变：${items?.c_nomen} 杂合突变，导致氨基酸发生剪接突变（${items?.p_nomen}）。ACMG 遗传变异信息详细解读如下：`
              }
            ]
          },
          {
            type: 'paragraph-2',
            children: [
              {
                text: `(${index + 1})${items?.c_nomen}（${
                  items?.transcript
                } ，${items?.var_location}），导致氨基酸改变 ${
                  items?.c_nomen
                }，为剪接突变。`
              }
            ]
          },
          {
            type: 'paragraph-2',
            children: [
              {
                text: '根据 ACMG 指南，该变异初步判定为:'
              }
            ]
          },
          {
            type: 'span-blod-red',
            children: [
              {
                text: `      致病性变异（${classify(
                  items?.acmg_evidences ?? []
                )}）${items?.acmg_evidences?.join('+')}`
              }
            ]
          },
          {
            type: 'p7',
            children: items.acmg_evidences
              ? items.acmg_evidences?.map((item: any) => {
                  const first = item.split('_')[0]
                  const text = ACMG_evidences_en[first]

                  const temp = userAcmgData.find(
                    (log) =>
                      log.variantKey ===
                        `${items.gene}-${items.c_nomen}-${items.transcript}` &&
                      `${first}${
                        judgeStrength(item) ? `-${judgeStrength(item)}` : ''
                      }` === log.acmgCriteria
                  )

                  return {
                    type: 'p9',
                    children: [
                      {
                        text: `${item}:${temp ? temp?.evidenceDetails : text}`
                      }
                    ]
                  }
                })
              : [
                  {
                    type: 'display-none',
                    children: [
                      {
                        text: ``
                      }
                    ]
                  }
                ]
          },
          {
            type: 'paragraph-2',
            children: [
              {
                text: `在正常人群数据库中的频率为 ${items.gnomAD_exome_ALL}；由于未收到父母样本，未进行基因变异来源验证；`
              }
            ]
          },
          {
            type: 'p9',
            children: [
              {
                text: ''
              }
            ]
          }
        ]
      }
    }),
    {
      type: 'h5-genetic',
      children: [
        {
          text: '2） 疾病临床描述'
        }
      ]
    },
    ...reportsVariants.map((items, index) => {
      return {
        type: 'paragraph-2',
        children: [
          {
            type: 'span-blod',
            children: [
              {
                text: `基因：${items.gene}`
              }
            ]
          },
          ...items.OMIMData.map((item: any, i: number) => {
            return {
              type: 'p9',
              children: [
                {
                  type: 'span-blod',
                  children: [
                    {
                      text: `(${i + 1})${item.pheno_name_cn}（OMIM：${
                        item.phenoMim
                      }）；${item.inheritance}`
                    }
                  ]
                },
                {
                  type: 'paragraph-2',
                  children: [
                    {
                      type: 'span-blod',
                      children: [
                        {
                          text: '疾病介绍：'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'paragraph-2',
                  children: [
                    {
                      text: `${item.phenoDescriptionCNStr.join('\n') ?? '无'}`
                    }
                  ]
                },
                {
                  type: 'paragraph-2',
                  children: [
                    {
                      type: 'span-blod',
                      children: [
                        {
                          text: '临床表型：'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'paragraph-2',
                  children: [
                    {
                      text: `${
                        item?.phenoClinicalFeaturesCNStr?.join('\n') ?? '无'
                      }`
                    }
                  ]
                }
              ]
            }
          }),
          {
            type: 'p9',
            children: [
              {
                text: ''
              }
            ]
          }
        ]
      }
    }),
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '建议：配偶针对上述检测基因进行基因筛查，建议接受遗传咨询。'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '疾病背景：'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       单基因疾病一般是由于一个基因出现的突变引致，可导致非常严重的后果，例如智力障碍、生长迟缓、发育 畸形、多器官缺陷及过早死亡。虽然每一种单基因疾病都非常罕见，但在新生婴儿期所有单基因疾病的总流行率 高达 10/1000，合计共占婴儿死亡率约 20%。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       很多严重的单基因疾病都属于常染色体隐性遗传病（AR），本身杂合携带不致病，但若配偶携带有相同基因 的突变，则后代会有 1/4 的可能性成为患者，若配偶携带不同基因的变异，则后代不会患该疾病。也就是当父亲 和母亲同时把一对相同基因上的变异遗传给后代时才会引致疾病。单基因疾病携带者，只遗传了父亲或母亲一方 的变异基因，他们不会发病，但会把变异遗传给下一代。如果父母都是相同基因变异携带者的话，则子女会有 25% 机会发病。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       X 连锁隐性遗传病（XR/XLR）理论上半合子变异致病，母亲为杂合携带者，不发病，儿子为半合子变异（hemi）， 发病，但也有部分女性杂合突变携带者会有临床表现；X 连锁显性遗传病（XD/XLD）通常携带者均有发病可能。常染色体显性遗传病（AD）分为自发突变导致的显性疾病和在家系中遗传的显性疾病。检测父母不能筛查子 代发生的自发变异；若家系中存在遗传病史，建议行诊断类检测，不建议筛查。建议筛查无明显遗传病表型或无 明确家族史育龄夫妇或辅助生殖人群。对于成年起病的遗传病和具有临床可干预性的显性遗传病，建议结合受检者的家族史进行遗传咨询。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       部分基因可导致常染色体显性和常染色体隐性的两种不同的遗传病，此类基因致病变异携带者患常染色体显 性疾病的风险增加。例如，ATM 基因可导致常染色体隐性共济失调毛细血管扩张症，也可导致常染色体显性肿瘤 易感，需关注携带者乳腺癌、卵巢癌和胰腺癌等肿瘤的患病风险。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       线粒体突变热点为母系遗传（Maternal inheritance）， 一般通过卵子的细胞质把致病变异遗传给子女。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '       据估计，每一个正常人都会携带 0-7 个可导致重大疾病的基因变异，若配偶携带的致病突变位于同一个基因 上，则非常有必要进行遗传咨询。 因为大部分的单基因疾病都不能根治，进行孕前单基因疾病筛查可提供准确的 孕前遗传学评估，以明确致病性基因变异遗传至下一代的风险。'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '姓名' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '样本编号' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '平均测序深度' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-c2',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '目标区域覆盖度' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '10X' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '20X' }]
                }
              ]
            }
          ]
        },
        ...samples.map((row) => {
          const fastQc = row.fastQc ?? {}
          const pctData = (fastQc.barChartData ?? []) as any[]
          const x1 = pctData.find((i) => i.name === '1x')?.value
          const x10 = pctData.find((i) => i.name === '10x')?.value
          const x20 = pctData.find((i) => i.name === '20x')?.value

          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.patient?.patientName ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.id ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: `${row.sample?.avgReadDepth ?? '-'}`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x10 ? `${x10}` : '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell-genetic',
                children: [
                  {
                    type: 'p3-center',
                    children: [
                      {
                        text: x20 ? `${x20}` : '-'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '方法学：'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '基因靶向捕获测序'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '局限性：'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '1.本检测项目针对相关基因外显子区进行检测。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '2.在数据分析时，为保证数据分析的精确性，目标区域内少部分测序质量过低的变异将被滤掉。不能分析高 GC 含量区、高度重复序列区、假基因相关区域的变异。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '3.此检测方法主要分析点突变和小片段缺失/插入变异，对于更大范围内的缺失/重复/结构变异，panel 范围内基  因外显子的部分缺失与重复等纯合变异能完全检测，杂合变异绝大多数可以检测到。但 CNV 检测由于存在数 据波动，部分杂合性缺失与重复（如 SMA ，DMD 外显子缺失重复、α地贫相关- α3.7 、-α4.2 等大片段杂合  缺失）结果存在检测不准的情况。对于α地贫相关- α3.7 和-α4.2，由于序列同源性高，杂合缺失结果判断受  reads 分布稳定性影响，有 10-20%概率不能够精准判断断裂点。对于 DMD 基因，纯合缺失可以准确判断，杂 合缺失受实验波动影响，有 10-20%可能性漏检。对可疑样本，需用其他方法进行验证。此外，未进行 NGS 测 序的家系样本不提供缺失重复结果。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '4.不能分辨变异在染色体上的顺反构型，不能检测染色体数目异常、易位/倒位等基因组结构变异以及生殖细胞 的嵌合突变。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '5.本项目仅报告承诺报告范围内已明确的致病性突变。此报告亦无法排除报告范围外其它突变的影响，无法排除 受检者下一代会因为新发（de novo）突变而导致相关疾病发生的可能。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '6.阴性结果不能排除受检者携带检测范围外致病变异的可能性，检测后剩余风险代表受检者检测结果为阴性时仍 为携带者的概率，生育风险代表受检者后代患有所检疾病的概率。'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: '备注：'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(1)    参考基因组版本为 GRCh37/hg19  ，核苷酸改变的位置信息是基于当前版本的基因组和转录本，不同基因组版本或不同转录本， 这些信息可能会有所不同。'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(2)    hom/het/hemi ：hom 表示此突变位点为纯合突变，het 表示此突变位点为杂合突变，hemi 表示此突变位点为半合子突变。'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(3)     蛋白功能预测软件 REVEL(rare exome variant ensemble learner) : Am J Hum Genet. 2016 Oct 6;99(4):877-885.[PMID: 27666373] ， D: 有害;LD:可能有害;U:不确定;LB:可能良性;B:良性.    spliceAI ：T:影响剪接;F:不影响剪接. -:未知'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(4)    根据美国医学遗传学与基因组学会（ACMG）发布的变异解读指南进行致病性分析：pathogenic/致病性变异；likely pathogenic/疑 似致病性变异；uncertain/临床意义未明变异；likely-benign/疑似良性变异；benign/良性变异。'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(5)    遗传方式：AR 表示常染色体隐性遗传；AD 表示常染色体显性遗传；XR 表示 X 染色体隐性遗传；XD 表示 X 染色体显性遗传。'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(6)    基因核苷酸变异的解释是基于目前对该基因的了解，随着研究的深入，这些解释也可能会发生改变。'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(7)    本检测仅对与疾病风险高度相关的变异进行一代测序验证。'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span',
          children: [
            {
              text: '(8)    人体表型可能受到基因、环境等多种因素影响，可能存在外显不全、表现度不一等情况，未检测出与疾病风险高度相关的变异， 不代表受检者没有风险，检测出与疾病风险高度相关的变异，也不代表受检者一定发病。'
            }
          ]
        }
      ]
    },
    {
      type: 'divider',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span-blod-red',
          children: [
            {
              text: '*'
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '相关检测结果仅供临床参考，不能作为唯一诊断依据，必要时请进行其它辅助检测。'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          type: 'span-blod-red',
          children: [
            {
              text: '*'
            }
          ]
        },
        {
          type: 'span',
          children: [
            {
              text: '本报告只对本次采集样本负责，如有疑问，请在 15 个工作日内与我们联系。'
            }
          ]
        }
      ]
    },
    {
      type: 'span-start',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'block-patient-info',
      children: [
        {
          type: 'p3',
          children: [
            {
              text: '检测者：'
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: '审核者：'
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `报告时间： ${
                formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
              }`
            }
          ]
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '附录1:'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '维生素 D 及钙吸收利用能力（VDR 基因）'
        }
      ]
    },
    {
      type: 'span-blod',
      children: [
        {
          text: `基于相关基因数据分析，对维生素 D  及钙的整体吸收利用能力${t(
            handleSetVlaue(setsValue)
          )}。`
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic-c4',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '主要参考结果' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic-c4',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '次要参考结果' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测位点' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '位点 ID' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测结果' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '能力高低' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测位点' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '位点 ID' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测结果' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '能力高低' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `FokI`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'rs2228570'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: setsValue.FokISet.label.split('').join('/')
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text:
                        setsValue.FokISet.value == 1
                          ? '正常'
                          : setsValue.FokISet.value == -1
                          ? '较低'
                          : '稍低'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'TaqI'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'rs731236'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: setsValue.TaqISet.label.split('').join('/')
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text:
                        setsValue.TaqISet.value == 1
                          ? '正常'
                          : setsValue.TaqISet.value == -1
                          ? '较低'
                          : '稍低'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `ApaI`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'rs7975232'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: setsValue.ApaISet.label.split('').join('/')
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text:
                        setsValue.ApaISet.value == 1
                          ? '正常'
                          : setsValue.ApaISet.value == -1
                          ? '较低'
                          : '稍低'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'G66567A'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'rs7967673'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: setsValue.G66567ASet.label.split('').join('/')
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text:
                        setsValue.G66567ASet.value == 1
                          ? '正常'
                          : setsValue.G66567ASet.value == -1
                          ? '较低'
                          : '稍低'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `BsmI`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'rs1544410'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: setsValue.BsmISet.label.split('').join('/')
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text:
                        setsValue.FokISet.value == 1
                          ? '正常'
                          : setsValue.FokISet.value == -1
                          ? '较低'
                          : '稍低'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: ''
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: ''
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: ``
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: ''
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '注：'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(1)  重点关注主要参考结果，综合多个位点吸收利用能力结果评估，整体吸收利用能力评级依次为“正常”、“中 等”和“偏低”。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(2)若主要参考结果中有多个位点为“稍低”，可能导致整体能力更低一些。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(3)基因数据仅供参考，VD 及钙是否需要额外补充，以及具体补充剂量，请根据个体年龄、营养状况、基因数据等因 素综合评估，遵医嘱。'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '叶酸吸收利用能力'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic-c4',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测结果' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '基因' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测位点' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测结果' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '综合风险' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `MTHFR`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'rs1801133 (C677T)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: setsValue2.C677T.label.split('').join('/')
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic-r3',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: t(handleSetVlaue2(setsValue2))
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `MTHFR`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'rs1801131 (A1298C)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: setsValue2.A1298C.label.split('').join('/')
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `MTRR`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: 'rs1801394 (A66G)'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: setsValue2.A66G.label.split('').join('/')
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '注：结果提示为“低风险”，提示受检者叶酸吸收利用能力可能不存在明显缺陷； '
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '结果提示为“中风险”，提示受检者叶酸吸收利用能力可能较低，需加强关注。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '结果提示为“高风险”，提示受检者叶酸吸收利用能力低，需重点关注。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '相关基因数据结果仅为提示信息，具体叶酸增补情况请临床综合评估。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '育龄期女性和男性叶酸补充参考计量：'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '检测结果' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '孕前 3 个月' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '孕早期' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '孕中期' }]
                }
              ]
            },
            {
              type: 'table-cell-color-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [{ text: '孕后期' }]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `未发现风险`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '400μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '400μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '注意食补叶酸'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '注意食补叶酸'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `低风险`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '400μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '400μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '400μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '400μg/d'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `中风险`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '400-600 μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '400-600 μg/d'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '并补充~2.6μg/d VB12'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '400 μg/d'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '并补充~2.6μg/d VB12'
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '400 μg/d'
                        }
                      ]
                    },
                    {
                      type: 'p3-center',
                      children: [
                        {
                          text: '并补充~2.6μg/d VB12'
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic-r2',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: `高风险`
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '800 μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '800 μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '800 μg/d'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-genetic',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '400μg/d'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-genetic-c4',
              children: [
                {
                  type: 'p3-center',
                  children: [
                    {
                      text: '对于 MTRR 66AG 或 GG 的受检者，还要增补~2.6 μg/dVB12'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '注：'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(1)  特殊人群推荐建议：对于有神经管畸形（缺陷）生育史妇女，以及夫妻一方患有神经管缺陷或男方既往有神经管 缺陷生育史的妇女，建议从妊娠或孕前 1-3 月，补充叶酸，叶酸补充剂量请咨询产科医生。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(2)  以上补充参考剂量指合成叶酸补充剂或强化剂的摄入量，不包括食物，具体请遵医嘱。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(3)  以上剂量参考《围受孕期增补叶酸预防神经管缺陷指南(2017)》[1]，《中国临床合理补充叶酸多学科专家共识》[2][3]和《中国疾病预防控制中心妇幼保健中心个体化推荐》等，  实际用量请遵临床医生建议。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(4)  叶酸补充可能影响锌代谢和维生素 B12（VB12），需平衡膳食。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(5)  叶酸与多种药物有相互作用（抗癫痫，抗感染药，茶碱类，抗肿瘤及其他），请及时与医生沟通和遵照医嘱。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(6)  妊娠期从增补剂或强化食品获取的叶酸可耐受最高摄入量为 1mg/d，加拿大妇产科学会建议，妊娠妇女每日补充0.4～1．0 mg 至分娩，并可进一步增补至产后 4～6 周或持续整个哺乳期。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(7)  富含叶酸的食物包括深绿色蔬菜（芦笋、菠菜、西兰花、黄豆等）、柑橘类水果、豆类、藜麦、坚果、鸭蛋、瘦 肉、动物肝脏等食物。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '(8)  叶酸在体内的代谢和吸收受多因素影响，例如遗传因素，生理状态，生活方式等，请遵照医嘱合理补充叶酸。'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '附录检测基因的临床意义：'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '1. 人类维生素 D 受体（vitamin D receptor,VDR）基因位于 12q12-q14 染色体上，是一种核转录因子。目前已鉴定出 4   种常见的多态性，即 ApaI、BsmI、FokI 和 TaqI[4]。以 BsmI 位点为例，基因突变型 BB 的 VDR 活性是正常基因型bb   活性的一半，可直接导致维生素 D 和钙的吸收能力下降，因此对应的补充剂量应相应增加才能满足机体的需要。近来 研究发现 VDR 基因多态性与多种妊娠并发症及不良妊娠结局相关，如妊娠期糖尿病、早产、早发型重度子痫前期、新生儿低出生体重等[5]。所以关于维 D 的补充剂量应该因人而异。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '2. 5, 10-亚甲基四氢叶酸还原酶 (MTHFR)在叶酸和同型半胱氨酸（homocysteine, Hcy）代谢通路中发挥重要作⽤ ， 可 介导⾎清同型半胱氨酸的清除，促进 DNA 甲基化反应，并影响 DNA 合成及修复等。编码 MTHFR 的基因存在多种单 核苷酸多态性，中国人群中最重要的为 C677T 变异[6] ，该位点 CT 基因型 MTHFR 的酶活性为 CC 基因型的 65% ，TT  基因型酶活性为 CC 基因型的 30% 。 在叶酸摄⼊不⾜的情况下， CT 或 TT 基因型的个体体内 Hcy⽔平显著升⾼或出 现⾼同型半胱氨酸⾎症[7]。大量循证证据和荟萃分析证明：MTHFR C677T 基因多态性影响神经管畸形、唐氏综合征、唇腭裂等新生儿缺陷等[8]。另⼀重要变异位点是 A1298C ， 该变异也可导致 MTHFR 酶活性的降低， 研究表明， A1298C 基因型可显著增加 Hcy⽔平。 另外， 当 MTHFR C677T 和 A1298C 同时发⽣杂合突变时可显著增加Hcy⽔平以及降低叶酸⽔平。 流⾏病学研究表明，A1298C 位点CC 纯合型或与C677T 位点同时为杂合型时，与神经 管畸形、不良妊娠等存在关联[9] [10]。'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '3. 甲硫氨酸合成酶还原酶（MTRR）是叶酸-Hcy 代谢过程中的另⼀关键酶，催化具有功能活性的甲硫氨酸合酶的重新 ⽣成， 维持叶酸代谢过程，介导叶酸的⽣物活性。MTRR 基因发⽣A66G 变异时， 使 MTRR  酶活性降低， 因⽽有活性的维⽣素 B12 减少， 导致甲硫氨酸合成酶的功能受影响，叶酸代谢出现障碍。研究还发现 MTRR A66G 与MTHFR C677T 在影响 Hcy⽔平⽅⾯存在联合作⽤ 。⼈群流⾏病学研究表明，MTRR A66G 变异和神经管畸形、先天 性⼼脏病、唐⽒综合征、围孕期综合征等相关。'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '参考文献：'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[1]围受孕期增补叶酸预防神经管缺陷指南⼯作组.  围受孕期增补叶酸预防神经管缺陷指南(2017).  中国⽣育健康杂志, 2017, (5): 401-410.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[2]中国临床合理补充叶酸多学科专家共识(2020).  中国医学前沿杂志, 2020, 12(11):19-37.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[3]中国临床合理补充叶酸多学科专家共识(2021).医药导报, 2021,40(1): 1-19.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[4]MAHYARA,AYAZIP , SARKHOSHAA,et al. Vitamin D receptor gene ( FokI，Taql，BsmI，and Apal) polymorphisms in children with urinary tract infection[ J]. Pediatr Res,2018 ,84(6)   ：527-532.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[5]LEECL,NGBK,WULL,etal. Vitamin D deficiency in pregnancy at term  ：risk factors and pregnancy outcomes [ J ]. HormMol Biol Clin Investig,2017,26(5)  ：1868-1883.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[6]Wang X, Fu J, Li Q, et al. Geographical and ethnic distributions of the MTHFR C677T, A1298C and MTRRA66G gene polymorphisms in Chinese populations: A meta-analysis. PLoS One. 2016, 11(4): e0152414.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[7]Li W, Dai S, Zheng J, et al. Homocysteine metabolism gene polymorphisms (MTHFR C677T, MTHFRA1298C, MTR A2756G and MTRRA66G) jointly elevate the risk of folate deficiency. Nutrients. 2015, 7(8): 6670-87.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[8]Rai V. Methylenetetrahydrofolate reductase C677T polymorphism and recurrent pregnancy loss risk in Asian population: A meta-analysis. Indian J Clin Biochem. 2016, 31(4): 402-13.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[9]秦奇.基因检测科学补充叶酸对妇女妊娠的影响[D] .郑州：郑州大学 ,2016.'
        }
      ]
    },
    {
      type: 'paragraph-2',
      children: [
        {
          text: '[10]Al-Achkar W, WafaA, Ammar S, et al. Association of methylenetetrahydrofolate reductase C677T and A1298C gene polymorphisms with recurrent pregnancy loss in Syrian women. Reprod Sci. 2017, 24(9): 1275-1279.'
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'signature-footer',
      children: [
        {
          text: formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
        }
      ]
    }
  ]
}
